<template>
  <div class="tw:flex tw:justify-center tw:min-h-screen tw:p-6 tw:pt-12">
    <div class="tw:flex tw:flex-col tw:items-start tw:gap-4 tw:w-full tw:max-w-[1000px] tw:max-h-screen">

      <a class="tw:flex tw:items-center tw:gap-1 tw:cursor-pointer tw:text-sm tw:font-semibold tw:text-(--text-color) tw:shrink-0" @click="logout">
        <IconGoogle name="arrow_back" size="16px" color="var(--text-color)" />
        Voltar
      </a>

      <TextPlay size="md" weight="semibold" color="var(--fontcolor)" :text="$t('auth.select_platform.instruction')" class="tw:mt-4 tw:shrink-0" />

      <div class="tw:flex tw:flex-col tw:gap-4 tw:w-full tw:overflow-y-auto tw:pb-6">
        <div
          v-for="painel in sites"
          :key="painel.id"
          class="tw:flex tw:flex-row tw:gap-4 tw:w-full tw:justify-between tw:p-4 tw:items-center tw:bg-(--box-background-color) tw:rounded-lg tw:border tw:border-(--input-border-color) tw:cursor-pointer tw:transition-all tw:hover:brightness-95 dark:tw:hover:brightness-110"
          @click="signInSite(painel.id)"
        >
          <div class="tw:w-[180px] tw:h-[70px] tw:py-[10px] tw:px-[26px] tw:bg-background tw:rounded-lg tw:border tw:border-(--input-border-color) tw:flex tw:items-center tw:justify-center tw:shrink-0">
            <img
              v-if="painel.logomarca || painel.logo"
              loading="lazy"
              :src="painel.logomarca || painel.logo"
              alt="logo"
              class="tw:w-full tw:h-full tw:object-contain"
            />
            <div v-else class="tw:flex tw:flex-col tw:items-center tw:gap-1">
              <IconGoogle name="image" size="1.2rem" color="var(--text-color)" />
              <TextPlay :text="$t('auth.select_platform.no_logo')" size="xs" color="var(--text-color)" />
            </div>
          </div>
          <div class="tw:flex-1 tw:min-w-0">
            <TextPlay size="sm" weight="semibold" color="var(--fontcolor)" :text="painel.name" />
            <TextPlay size="sm" color="var(--text-color)" :text="painel.description" />
          </div>
          <ButtonPlayV2
            variant="filled"
            size="sm"
            :icon-right="'chevron_right'"
            :text="$t('auth.select_platform.access_button')"
            @click.stop="signInSite(painel.id)"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts" setup>
import { useAuthStore } from "@/store/auth.store";
import { play } from "@voomp/play-back";
import { ref, onMounted } from "vue";
import { ButtonPlayV2, IconGoogle } from "@/components/atomic"


const authStore = useAuthStore()

const sites = ref<Awaited<ReturnType<typeof play.site.list_by_current_member>>>([])

async function fetch() {
  const result = await play.site.list_by_current_member({})
  sites.value = result
}

async function signInSite(siteId: number) {
  authStore.SignInSite({ siteId })
}

function logout() {
  authStore.logout()
}

onMounted(() => {
  fetch()
})
</script>
